import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/kickstarter-k': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M147.3 114.4v70.6l82.8-118.2c31.2-44.4 83.3-41.8 113.6-12.8 27.9 26.7 27.8 65.1 10.4 89.8l-74.9 107.4 90.8 114.8c19.9 24.8 19.6 64.6-7.4 92.2-31.1 30.7-80.5 27.2-103.2 0l-112.1-138.3v76.5c0 57.8-32.6 83.4-72.4 83.4-49.6 0-74.9-36.1-74.9-83.4v-283c0-45.2 26.2-81.4 73.9-81.4 40.9 0 73.4 26.2 73.4 82.4z'
      }
    ]
  }
})
